// src/context/SidebarContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface SidebarContextProps {

    isTooltipHovered: boolean;
    setIsTooltipHovered: (value: boolean) => void;

}

const SidebarContext = createContext<SidebarContextProps | undefined>(undefined);

export const CustomHoverContext: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [customVerticalSidebar, setcustomVerticleSidebar] = useState(false);
    const [isTooltipHovered, setIsTooltipHovered] = useState(false);

    return (
        <SidebarContext.Provider value={{    isTooltipHovered,
            setIsTooltipHovered}}>
            {children}
        </SidebarContext.Provider>
    );
};

// Custom Hook for easy access
export const useSidebarMenuHover = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebarMenu must be used within a SidebarProvider');
    }
    return context;
};
